export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;
